import { render, staticRenderFns } from "./NewGamePopup.vue?vue&type=template&id=31ce70f4&scoped=true"
import script from "./NewGamePopup.vue?vue&type=script&lang=js"
export * from "./NewGamePopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=31ce70f4&prod&scoped=true&lang=css&external"
import style1 from "./NewGamePopup.vue?vue&type=style&index=1&id=31ce70f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce70f4",
  null
  
)

export default component.exports